import type { AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import type { IResponseFilters } from 'entities/Contacts/api/filterTypes'
import type { IResponseConversations } from 'entities/Conversation'
import {
  type IParamsCreateSmartView,
  type IParamsSmartViewConversations,
  type IParamsUpdateSmartView,
  type IParamsUpdateSmartViewFavorite,
  type IResponseSmartView,
} from './types'

class Api {
  getSmartViews(): Promise<AxiosResponse<IResponseSmartView[]>> {
    return baseApi.get('smart-views')
  }

  getSmartViewById(id: number): Promise<AxiosResponse<IResponseSmartView>> {
    return baseApi.get(`smart-views/${id}`)
  }

  createSmartView(params: IParamsCreateSmartView): Promise<AxiosResponse<IResponseSmartView>> {
    return baseApi.post('smart-views', params)
  }

  updateSmartView(
    id: number,
    params: IParamsUpdateSmartView
  ): Promise<AxiosResponse<IResponseSmartView>> {
    return baseApi.put(`smart-views/${id}`, params)
  }

  deleteSmartView(id: number): Promise<AxiosResponse<void>> {
    return baseApi.delete(`smart-views/${id}`)
  }

  updateSmartViewFavorite(
    params: IParamsUpdateSmartViewFavorite
  ): Promise<AxiosResponse<IResponseSmartView>> {
    return baseApi.post('smart-views/favorite', params)
  }

  getSmartViewFilters(options?: AxiosOptions): Promise<AxiosResponse<IResponseFilters>> {
    return baseApi.get('smart-views/filters', options)
  }

  getSmartViewConversationsList(
    id: number,
    params: IParamsSmartViewConversations,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseConversations>> {
    return baseApi.get(`smart-views/${id}/conversations`, { params, ...options })
  }
}

export const SmartViewsApi = new Api()
